const getLocationString = (
  nickName: string,
  city: string,
  state: string
): string => {
  return `${nickName}${
    nickName.toLowerCase().includes(city.toLowerCase()) ? '' : `, ${city}`
  }${nickName.includes(state) ? '' : `, ${state}`}`
}

export default getLocationString
